import styled from '@emotion/styled';
// import { themeGet } from '@styled-system/theme-get';
import { StyledColumnHeader } from '../ColumnHeader/styles';

export const StyledContactUsBlock = styled.div`
  ${StyledColumnHeader} {
    p {
      border: 0;
      padding: 0;
    }
  }
`;

export default StyledContactUsBlock;
